export default "__VITE_PUBLIC_ASSET__86df76f9__"